import React from 'react';

const Footer = () => {
  return (
    <footer className="py-8 mt-12 bg-transparent text-center">
      <div className="container mx-auto px-4 text-sm text-gray-600">
        <p className="mb-2">
          Hosted by <a href="https://canarycanary.com" className="text-indigo-500 hover:text-indigo-700 underline">Canary Canary</a>
        </p>
        <p>
          Have questions? <a href="mailto:inquiry@canarycanary.com" className="text-indigo-500 hover:text-indigo-700 underline">Email inquiry@canarycanary.com</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer; 